export default __webpack_public_path__ + "static/Inter-Bold-5acf0813743b359f2cbf37fac572d800.woff";